import React from "react";
import { Box, Paper, Text, Stack } from "@mantine/core";

/**
 * Nested block inside an AR Form part (Part A/B/C section).
 * Parent FormSection already provides the outer card.
 */
const OrderArFormBlock = ({
  title,
  subtitle,
  children,
  mb = "md",
  noPadding = false,
}) => (
  <Paper withBorder radius="sm" mb={mb} p={noPadding ? 0 : "md"}>
    {(title || subtitle) && (
      <Box mb={children ? "sm" : 0}>
        {title && (
          <Text size="sm" weight={600}>
            {title}
          </Text>
        )}
        {subtitle && (
          <Text size="xs" color="dimmed" mt={title ? 4 : 0}>
            {subtitle}
          </Text>
        )}
      </Box>
    )}
    {children}
  </Paper>
);

export const OrderArFormStack = ({ children }) => (
  <Stack spacing="md">{children}</Stack>
);

export default OrderArFormBlock;
